<template>
	<div 
		class="sheet-view-group-tab-container"
		:data-query-selector="`sheet-view-group-tab-${sheetViewGroup.$internals.metaProperties.meta.guid}`"
	>
		<div class="sheet-view-group-tab">
			<div class="sheet-view-tabs">
				<sheet-view-tab
					v-for="(sheetView, sheetViewIndex) in sortedSheetViews"
					:key="sheetView.$internals.metaProperties.meta.guid"
					:sheetViewGroupIndex="sheetViewGroupIndex"
					:sheetViewIndex="sheetViewIndex"
					:sheetView="sheetView"
					:selectedSheetViewGUID="selectedSheetViewGUID"
				></sheet-view-tab>
			</div>
			<div class="sheet-view-folder-label">
				Folder {{sheetViewGroupIndex+1}}
			</div>		
		</div>
	</div>
</template>

<script type="text/javascript">

	import SheetViewTab from 'vue/sheet-views/common/sheet-view-tab.vue';

	export default {
		components:{
			SheetViewTab,
		},		
		props:{
			sheetViewGroupIndex:{
				required: true,
				type: Number,
			},
			sheetViewGroup:{
				required: true,
				type: Object,
			},
			selectedSheetViewGUID:{
				required: true,				
			}
		},
		methods:{

		},
		computed:{
			sortedSheetViews(){
				const sortedArray = this.sheetViewGroup.sheetViews.slice().sort(function compare(a, b){
					return a.sortOrder - b.sortOrder;
					// return a.$internals.metaProperties.meta.dateCreated - b.$internals.metaProperties.meta.dateCreated;
				});
				return sortedArray;
			}
		}
	}
</script>


<style lang="scss" scoped>

	.sheet-view-group-tab-container{
		@include flex(row);
	}
	
	.sheet-view-group-tab{
		@include flex(column);

		color: black;
		background: $p-color-grey-100;		
	}

	.sheet-view-tabs{
		color: black;
		display: flex;
		flex-direction: row;
	    max-height: 40px;	    

	    // add borders to the sheet view tabs to avoid double borders
	    & > * {
	    	border-bottom: 1px solid #C3C9D4;
	    	border-left: 1px solid #C3C9D4;

	    	&:last-child{
	    		border-right: 1px solid #C3C9D4;
	    	}
	    }
	}

	.sheet-view-folder-label{
		@include flex(row, center, center);

		color: $p-color-grey-500;

		height: 30px;
		padding: 0 9px;
		text-align: center;
		font-weight: 600;
		font-size: 13px;
		line-height: 26px;
		letter-spacing: 0.15px;

	}

</style>